<template>
    <KvFileDropzone
        v-bind="$attrs"
        v-on="$listeners"
        variant="outlined"
        size="large"
    />
</template>

<script>
import KvFileDropzone from "../../components/inputs/kv-file-dropzone.vue";

export default {
    name: "BenefitsFileUpload",
    components: {
        KvFileDropzone,
    },
    inheritAttrs: false,
};
</script>
